import { CollectionHelper } from './collection-helper';

export class StringHelper {
  private static NO_TRANSFORM: (s: string) => string = (s: string) => s;

  public static join(strings: Array<string>, sep: string): string {
    if (strings == null || strings.length === 0) {
      return '';
    }
    let toReturn = '';
    let first = true;
    for (let part of strings) {
      if (!this.isEmpty(part)) {
        toReturn += first ? part : sep + part;
        first = false;
      }
    }
    return toReturn;
  }

  // TODO if necessary, adjust for arbitrary property depth
  public static joinStringProperty(
    objs: Array<any>,
    prop: string,
    sep: string,
    transform: (s: string) => string = this.NO_TRANSFORM
  ): string {
    if (objs == null || objs.length === 0) {
      return '';
    }
    let toReturn = '';
    let first = true;
    for (let obj of objs) {
      if (obj != null && !this.isEmpty(obj[prop])) {
        toReturn += first ? transform(obj[prop]) : sep + transform(obj[prop]);
        first = false;
      }
    }
    return toReturn;
  }

  public static isEmpty(s: string): boolean {
    return s == null || s === '';
  }

  public static isEmptyOrWhiteSpace(s: string): boolean {
    return s == null || s === '' || s.trim().length === 0;
  }

  public static shortenText(text: string, cutoff = 10) {
    if (text == null) {
      return '';
    }
    text = text.trim();
    if (text.length > cutoff) {
      return text.substring(0, cutoff - 1) + '...';
    } else {
      return text;
    }
  }

  public static transform(s: string, ...transforms: Function[]): string {
    if (s == null) {
      return null;
    }

    if (!CollectionHelper.isPopulated(transforms)) {
      return s;
    }

    return transforms.reduce(
      (intermediate, transform) => transform.call(intermediate),
      s
    );
  }

  public static equalUnderTransforms(
    s1: string,
    s2: string,
    ...transforms: Function[]
  ): boolean {
    return (
      (s1 == null && s2 == null) ||
      (s1 != null &&
        s2 != null &&
        this.transform(s1, ...transforms) === this.transform(s2, ...transforms))
    );
  }

  public static equalUnderTrimAndLowerCase(s1: string, s2: string): boolean {
    return StringHelper.equalUnderTransforms(
      s1,
      s2,
      String.prototype.trim,
      String.prototype.toLowerCase
    );
  }
}
